export default () => ({
  trigger: {
    name: 'content_blocks.product_row.show_energy_label',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: 'energy_label',
      },
    },
    nonInt: true,
  },
});
